import domToImage from "dom-to-image";
import React, { useEffect, useRef, useState } from "react";
import Draggable from "react-draggable";
import { useNavigate } from "react-router-dom";
import { SketchPicker } from "react-color";
import { toast } from "react-toastify";
import {
  default as LeftArrow
} from "../../assets/svg/LeftArrowIcon.svg";
import {
  default as RightArrow
} from "../../assets/svg/RightArrow.svg";
import colorBall from "../../assets/svg/colorBall.svg";
import threeDot from "../../assets/svg/more-2-fill.svg";
import music from "../../assets/svg/music-fill.svg";
import textSvg from "../../assets/svg/text.svg";
import styles from "./PostWrapper.module.scss";

const TextBox = ({
  setImagesArray,
  setTextBox,
  setUploadSection,
  text,
  setText,
  bgColor,
  setBgColor,
}) => {
  const navigate = useNavigate();
  const [colorPicker, setColorPicker] = useState(false);
  const [textColorPicker, setTextColorPicker] = useState(false);
  const [textColor, setTextColor] = useState({ r: 255, g: 255, b: 255, a: 1 });

  const textRef = useRef();

  const handelSubmit = () => {
    if (text === "") return toast.warn("Please write something !");
    const div = document.getElementById("text-capture-area");

    if (div) {
      domToImage
        .toPng(div, {
          filter: (node) => {
            if (node.classList) {
              return (
                !node.classList.contains(styles.controls) &&
                !node.classList.contains(styles.CancelBtn) &&
                !node.classList.contains(styles.ColorPicker) &&
                !node.classList.contains(styles.ColorPickerText)
              );
            }
            return true;
          },
        })
        .then(function (dataUrl) {
          fetch(dataUrl)
            .then((res) => res.blob())
            .then((blob) => {
              const file = new File([blob], "Text Story", {
                type: "image/png",
              });
              setImagesArray([file]);
              setTextBox(false);
              navigate("/UploadPost", {
                state: {
                  fileData: file,
                  caption: "",
                  isTextPost: true,
                  originalText: text,
                  originalBgColor: bgColor,
                },
              });
            });
        })
        .catch(function (error) {
          console.error("Error converting textarea to image:", error);
        });
    }
  };

  useEffect(() => {
    textRef?.current?.focus();
  }, []);

  return (
    <div
      className={styles.TextBox}
      id="text-capture-area"
      style={{
        background: `rgba(${bgColor.r},${bgColor.g},${bgColor.b},${bgColor.a})`,
      }}
    >
      <div className={styles.controls}>
        <div className={styles.LeftControls}>
          <img
            src={threeDot}
            alt="Options"
            onClick={() => toast.info("Coming Soon...")}
          />
          <img
            src={textSvg}
            alt="Text Color"
            onClick={() => setTextColorPicker(!textColorPicker)}
          />
          <img
            src={colorBall}
            alt="Background Color"
            onClick={() => setColorPicker(!colorPicker)}
          />
          <img
            src={music}
            alt="Music"
            onClick={() => toast.info("Music Clicked")}
          />
        </div>

        <img
          src={RightArrow}
          alt="Next"
          onClick={handelSubmit}
          className={styles.ArrowRight}
        />
      </div>

      <button className={styles.CancelBtn} onClick={() => setTextBox(false)}>
        Cancel
      </button>

      {colorPicker && (
        <div className={styles.ColorPicker}>
          <SketchPicker
            color={bgColor}
            onChange={(e) => {
              // setBgColor(e.hex);
              setBgColor(e.rgb);
            }}
          />
        </div>
      )}

      {textColorPicker && (
        <div className={styles.ColorPickerText}>
          <SketchPicker
            color={textColor}
            onChange={(e) => {
              setTextColor(e.rgb);
            }}
          />
        </div>
      )}

      <Draggable bounds="parent">
        <textarea
          id="textarea"
          className={styles.Textarea}
          ref={textRef}
          defaultValue={text}
          placeholder="Type your story here..."
          onChange={(e) => setText(e.target.value)}
          onClick={() => {
            setColorPicker(false);
            setTextColorPicker(false);
          }}
          style={{
            background: `transparent`,
            color: `rgba(${textColor.r},${textColor.g},${textColor.b},${textColor.a})`,
            fontSize: `${
              text.length >= 28
                ? text.length >= 70
                  ? text.length >= 145
                    ? text.length >= 275
                      ? text.length >= 575
                        ? text.length >= 775
                          ? text.length >= 1130
                            ? text.length >= 2000
                              ? "1rem"
                              : "1.2rem"
                            : "1.5rem"
                          : "1.8rem"
                        : "2rem"
                      : "2.5rem"
                    : "3rem"
                  : "4rem"
                : "5rem"
            }`,
          }}
        ></textarea>
      </Draggable>
    </div>
  );
};

export default TextBox;
